import React from "react";
import "./PartnerFooter.css";
import { Paper } from "@material-ui/core";

const langData = require("../../../Data/language.json");

export default function PartnerFooter(props) {
  if (props.isLoggedIn === false) {
    var policyText = (
      <div id="policyHolder">
        <hr />{" "}
        <p
          className="policyText"
          onClick={() => props.toggleInputMode("policy")}
        >
          {langData[props.language].footer.policy}
        </p>
      </div>
    );
  } else {
    policyText = <div></div>;
  }

  return (
    <div className="container-fluid col-lg-8 col-md-11 col-sm-11 footer">
      <p className="footerText">Partners:</p>
      <Paper elevation={6} id="footerPaper">
        <div id="logoHolder">
          <a href="https://kth.se/">
            <img
              className="Logo"
              src={require("../../../Images/kthLogo2.svg")}
              alt="KTH Logo"
            ></img>
          </a>
          <a href="https://consupedia.se/">
            <img
              className="Logo"
              src={require("../../../Images/ConsupediaLogo.png")}
              alt="Consupedia Logo"
            ></img>
          </a>
        </div>
        {policyText}
      </Paper>
    </div>
  );
}
